export const KYC_TYPES = {
  GETBANKINGFIELDS_BY_ISO2_BEGIN: 'GETBANKINGFIELDS_BY_ISO2_BEGIN',
  GETBANKINGFIELDS_BY_ISO2_SUCCESS: 'GETBANKINGFIELDS_BY_ISO2_SUCCESS',
  GETBANKINGFIELDS_BY_ISO2_FAILURE: 'GETBANKINGFIELDS_BY_ISO2_FAILURE',
};
